import { service } from '../axios';
export function getAvailableCategoryCounts() {
    return service({
        url: '/reservation/getAvailableCategoryCounts',
        method: 'get'
    });
}
export function getLabSchedulesByDate(params) {
    return service({
        url: '/reservation/getScheduleLab',
        method: 'get',
        params
    });
}
export function getDeviceSchedulesByDate(params) {
    return service({
        url: '/reservation/getScheduleDevice',
        method: 'get',
        params
    });
}
export function checkReservationConflict(data) {
    return service({
        url: '/reservation/checkConflict',
        method: 'post',
        data
    });
}
export function createReservation(data) {
    return service({
        url: '/reservation/create',
        method: 'post',
        data
    });
}
export function approveReservation(data) {
    return service({
        url: '/reservation/approveReservation',
        method: 'post',
        data
    });
}
export function getReservationDeviceByRsId(params) {
    return service({
        url: '/reservation/getReservationDeviceByRsId',
        method: 'get',
        params
    });
}
export function getReservationDeviceByReservationId(params) {
    return service({
        url: '/reservation/getReservationDeviceByReservationId',
        method: 'get',
        params
    });
}
export function getTeacherCourseOptions(params) {
    return service({
        url: '/courseSchedule/getTeacherCourseOptions',
        method: 'get',
        params
    });
}
export function getStudentCourseOptions(params) {
    return service({
        url: '/courseSchedule/getStudentCourseOptions',
        method: 'get',
        params
    });
}
//作业提交部分
export function submitCourseWork(data) {
    return service({
        url: '/submission/courseSubmit',
        method: 'post',
        data
    });
}
export function getMySubmission(params) {
    return service({
        url: '/submission/getMySubmission',
        method: 'get',
        params
    });
}
export function getSubmissionList(params) {
    return service({
        url: '/submission/list',
        method: 'get',
        params
    });
}
export function gradeSubmission(data) {
    return service({
        url: '/submission/grade',
        method: 'post',
        data
    });
}
export function getMyCourseSchedule(params) {
    return service({
        url: '/courseSchedule/getMySchedule',
        method: 'get',
        params
    });
}
export function getMyReservation(params) {
    return service({
        url: '/courseSchedule/getMyReservation',
        method: 'get',
        params
    });
}
export function getMyReservationWithStats(params) {
    return service({
        url: '/courseSchedule/getMyReservationWithStats',
        method: 'get',
        params
    });
}
export function cancelReservation(params) {
    return service({
        url: '/courseSchedule/cancelReservation',
        method: 'post',
        params
    });
}
